function n(n){n.then(null,(function(n){console.error(n)}))}export{n as forget};
